import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

const reportAnimate = () => {
  const reportGrids = gsap.utils.toArray('.report-list .grid');
  gsap.from(reportGrids, {
    opacity: 0,
    y: 30,
    duration: 0.6,
    stagger: 0.3,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.report-list',
      start: 'top 80%',
      end: 'bottom 50%',
      // markers: true,
    },
  });
};
export const gsapAnimation = () => {
  reportAnimate();
};

export const gsapAnimationUpdate = () => {
  ScrollTrigger.refresh();
};
